angular.module("admin").factory("AdminCompaniesService", ["$http", "ENV", function ($http, ENV) {

	/**
	 * API
	 */
	return {
		addCompany: addCompany,
		deleteCompany: deleteCompany,
		deleteLine: deleteLine,
		edit: editCompany,
		getCompany: getCompany,
		getAll: getAllCompanies,
	};


	/**
	 * Récupérer toutes les adminCompanies
	 * @returns {*}
	 */
	function getAllCompanies() {
		return $http.get(ENV.API_URL + "/admin/companies");
	}

	/**
	 * Mettre à jour un adminCompanies.
	 * @param company
	 * @returns {*|HttpPromise}
	 */
	function editCompany(company) {
		return $http.put(ENV.API_URL + "/admin/companies/" + company.id, company);
	}


	/**
	 * Récupérer un adminCompanies par son ID.
	 *
	 * @param id l'Id du company à récupérer.
	 * @returns {*}
	 */
	function getCompany(id) {
		return $http.get(ENV.API_URL + "/admin/companies/" + id);
	}

	/**
	 * Supprimer un company.
	 *
	 * @param company le company à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteCompany(companyId) {
		return $http.delete(ENV.API_URL + "/admin/companies/" + companyId);
	}

	function  deleteLine(lineId){
		return $http.delete(ENV.API_URL + "/lines/" + lineId);
	}


	/**
	 * POster un company vers le serveur.
	 * @param company
	 * @returns {*|HttpPromise}
	 */
	function addCompany(company) {
		return $http.post(ENV.API_URL + "/admin/companies", company);
	}


}]);
